import { useHandlers } from '../../../context/page-context';
import type { DiscountsApiContract } from '../api';

export function useDiscountsApi(): { discountsApi: DiscountsApiContract } {
  const { apis } = useHandlers();
  return { discountsApi: apis.discounts };
}
